<template>
  <SrpModal :isVisible="props.isVisible" @update:isVisible="isVisible => emit('update:isVisible', isVisible)">
    <template #content>
      <div class="global-standard-font">
        <div style="margin-bottom: 32px">
          <h1 class="global-h1" style="margin-bottom: 10px; text-wrap: balance">Generate Adventures</h1>
          <p class="global-p" style="text-wrap: balance">Create AI-generated adventures from this collaboration content.</p>
        </div>

        <h4 class="global-h4" style="margin-bottom: 10px">How Many Adventures?</h4>
        <div style="margin-bottom: 24px; display: flex; align-items: center">
          <NumberInputWithPlusMinus size="medium" :min="1" :max="4" isPositiveOnly v-model:value="adventureCount" style="margin-right: 14px" />
          <b>Adventures (1-4)</b>
        </div>

        <div class="title-and-form-element" style="margin-bottom: 20px">
          <h4 class="global-h4 title-and-form-element__title">
            (Optional) Guidance
            <span style="font-weight: 500; color: rgba(0, 0, 0, 0.5)"> - Instructions for the AI</span>
          </h4>
          <textarea
            class="global-textarea title-and-form-element__form-element"
            style="height: 110px; min-height: 110px"
            v-model="customerGuidance"
            placeholder="E.g., Focus on family-friendly activities, include historical context, make it romantic..."
          />
        </div>
      </div>
    </template>

    <template #footer>
      <SrpButton color="gray" fill="outlined" style="margin-right: 12px" @click="emit('update:isVisible', false)">Cancel</SrpButton>

      <SrpButton @click="handleGenerate">
        <template #icon>
          <IconEmbedded name="ai_2" :size="22" color="rgba(255, 255, 255, 0.4)" />
        </template>
        Generate
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

// Components
import NumberInputWithPlusMinus from "@components/ui/NumberInputWithPlusMinus.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import SrpModal from "@components/ui/SrpModal.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = withDefaults(
  defineProps<{
    isVisible: boolean;
  }>(),
  {
    isVisible: false,
  }
);

const emit = defineEmits<{
  (e: "update:isVisible", value: boolean): void;
  (e: "generate", value: { count: number; guidance: string }): void;
}>();

// Adventure count ============================================================
const adventureCount = ref<number>(2);

// Customer guidance ==========================================================
const customerGuidance = ref<string>("");

// Handle generate ============================================================
function handleGenerate() {
  emit("generate", {
    count: adventureCount.value,
    guidance: customerGuidance.value,
  });
  emit("update:isVisible", false);
}

// Reset values when modal closes =============================================
watch(
  () => props.isVisible,
  newVal => {
    if (newVal) {
      adventureCount.value = 2;
      customerGuidance.value = "";
    }
  }
);
</script>

<style scoped lang="scss">
.title-and-form-element {
  &__title {
    margin-bottom: 8px;
  }
}
</style>
